import * as React from 'react';
import * as styles from './MortgageCalculator.css';

interface IMortgageCalculatorProps {
  propertyCost: React.ReactNode;
  downPayment: React.ReactNode;
  downPaymentLabels: React.ReactNode;
  creditTerm: React.ReactNode;
  creditTermLabels: React.ReactNode;
  rate: React.ReactNode;
  rateLabels: React.ReactNode;
  summary: React.ReactNode;
}

export function MortgageCalculator({
  propertyCost,
  downPayment,
  downPaymentLabels,
  creditTerm,
  creditTermLabels,
  rate,
  rateLabels,
  summary,
}: IMortgageCalculatorProps) {
  return (
    <article className={styles['container']}>
      <div className={styles['side']}>
        {propertyCost}

        <div className={styles['slider-item']}>
          {downPayment}
          {downPaymentLabels}
        </div>

        <div className={styles['slider-item']}>
          {creditTerm}
          {creditTermLabels}
        </div>

        <div className={styles['slider-item']}>
          {rate}
          {rateLabels}
        </div>
      </div>

      <div className={styles['side']}>{summary}</div>
    </article>
  );
}
